// extracted by mini-css-extract-plugin
export default {"card-browser-filter":"card-browser-filter","popup-menu":"popup-menu"};